import * as Yup from "yup";

export namespace ValidationHelper {
    const phoneRegExp = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

    export const yupValidatePhone = () => {
        return Yup.string().matches(phoneRegExp, "Has to be 10 digits.").nullable();
    };
}
